module.exports = __webpack_public_path__ + "media/36.fc2a9835.mp3";